"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconArrowsReverse = function SvgIconArrowsReverse(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "arrows reverse icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Arrows Reverse Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.628 5.83L27.458 8l5.05 5.05H20.873A16.893 16.893 0 004 29.93h3.063a13.825 13.825 0 0113.811-13.81h11.64l-5.048 5.048 2.17 2.17c2.418-2.418 5.629-5.658 8.747-8.776zM40.93 18.077a13.825 13.825 0 01-13.81 13.811H15.48l5.055-5.056-2.17-2.17c-2.418 2.418-5.629 5.666-8.747 8.784l8.747 8.724 2.17-2.162-5.048-5.05H27.12A16.893 16.893 0 0044 18.078z"
  }));
};

var _default = SvgIconArrowsReverse;
exports.default = _default;